import { AppRoute } from "@/routes/types";
import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

export const publicRoutes: AppRoute[] = [
  {
    path: paths.app.login.path,
    page: lazy(() => import("@/pages/login").then((module) => ({ default: module.LoginPage }))),
    permissions: paths.app.login.permissions,
  },
];
